export const config = {
  endpoints: {
    getCalendarLink: (grantId: string, email: string) =>
      `/schedulereditor/index/getcalendarlink?grant_id=${grantId}&email=${email}`,
  },
};
